import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Link,
  Stack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MAIN_NAV, PRODUCT_CATEGORIES } from '../../config/navigation';
import { SERVICES } from '../../data/services';
import SiesaLogo from '../ui/SiesaLogo';

const SUBMENUS = {
  services: SERVICES.map(s => ({ label: s.title, href: '/services' })),
  products: [
    ...PRODUCT_CATEGORIES.map(c => ({
      label: c.label,
      href: `/products/${c.slug}`,
    })),
  ],
  projects: [
    { label: 'Galería de proyectos eléctricos', href: '/projects' },
    { label: 'Ingeniería Digital & Software', href: '/tecnologia' },
  ],
};

export default function MobileMenu({ isOpen, onClose }) {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement="left"
      size="xs"
    >
      <DrawerOverlay backdropFilter="blur(6px)" bg="blackAlpha.700" />
      <DrawerContent bg="brand.900" color="white">
        <DrawerCloseButton
          aria-label="Cerrar el menú"
          minW="44px"
          minH="44px"
          color="white"
          _hover={{ bg: 'whiteAlpha.200' }}
          top={3}
          right={3}
        />
        <DrawerHeader borderBottomWidth="1px" borderColor="whiteAlpha.200" px={6} py={5} bg="brand.900">
          <SiesaLogo variant="navbar" h="70px" maxH="80px" w="auto" alt="SIESA Logo" />
        </DrawerHeader>
        <DrawerBody px={0} py={4}>
          <Stack as="nav" aria-label="Navegación móvil" spacing={0}>
            {MAIN_NAV.map(item =>
              item.menu ? (
                <Accordion key={item.label} allowToggle>
                  <AccordionItem border="none">
                    <AccordionButton
                      px={6}
                      py={3.5}
                      minH="44px"
                      fontWeight={600}
                      fontSize="sm"
                      color="white"
                      _hover={{ bg: 'whiteAlpha.100' }}
                    >
                      <Box flex="1" textAlign="left">
                        {item.label}
                      </Box>
                      <AccordionIcon color="whiteAlpha.800" />
                    </AccordionButton>
                    <AccordionPanel pb={2} pl={9} pr={6} bg="blackAlpha.300">
                      <Stack spacing={0}>
                        {SUBMENUS[item.menu].map(entry => (
                          <Link
                            key={entry.label}
                            as={RouterLink}
                            to={entry.href}
                            onClick={onClose}
                            py={2.5}
                            minH="44px"
                            fontSize="sm"
                            color="whiteAlpha.800"
                            _hover={{ color: 'white' }}
                          >
                            {entry.label}
                          </Link>
                        ))}
                      </Stack>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              ) : (
                <Link
                  key={item.label}
                  as={RouterLink}
                  to={item.href}
                  onClick={onClose}
                  px={6}
                  py={3.5}
                  minH="44px"
                  fontWeight={600}
                  fontSize="sm"
                  color="white"
                  _hover={{ bg: 'whiteAlpha.100', color: 'brand.100' }}
                >
                  {item.label}
                </Link>
              )
            )}
          </Stack>

          <Box px={6} pt={8}>
            <Button
              as={RouterLink}
              to="/contact?subject=quote"
              onClick={onClose}
              bg="white"
              color="brand.900"
              _hover={{ bg: 'brand.100' }}
              w="full"
              fontWeight="semibold"
            >
              Solicitar cotización
            </Button>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
